module.exports = __webpack_public_path__ + "static/media/8OLA1.8b4530f9.jpg";